import { AbstractControl, ValidatorFn } from '@angular/forms';

export const requiredValidator = (): ValidatorFn => {
  return (control: AbstractControl) => {
    let value = control.value;

    if (typeof value === 'string') {
      value = value.trim();
    }

    return (value == null || value.length === 0)
      ? { required: true }
      : null;
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/validators/required.validator.ts